import React from 'react';

export function Calendar () {
    return(
        <svg className="date-picker-new" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_11856_83441)">
                <path d="M1.71476 2.85626C1.41165 2.85626 1.12096 2.97667 0.906635 3.191C0.692307 3.40532 0.571899 3.69601 0.571899 3.99912V14.2848C0.571899 14.5879 0.692307 14.8786 0.906635 15.093C1.12096 15.3073 1.41165 15.4277 1.71476 15.4277H14.2862C14.5893 15.4277 14.88 15.3073 15.0943 15.093C15.3086 14.8786 15.429 14.5879 15.429 14.2848V3.99912C15.429 3.69601 15.3086 3.40532 15.0943 3.191C14.88 2.97667 14.5893 2.85626 14.2862 2.85626H12.0005" stroke="#717171" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M0.571899 7.43124H15.429" stroke="#717171" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4.00073 0.571869V5.1433" stroke="#717171" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.0007 0.571869V5.1433" stroke="#717171" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 2.85626H9.71429" stroke="#717171" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_11856_83441">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
